import styled from '@mui/system/styled'

type WrapperProps = {
  disableBoxShadow?: boolean
  bgColor?: string
  isToReceive?: boolean
  isExpanded?: boolean
}
export const Wrapper = styled('div', {
  shouldForwardProp: (prop) =>
    !['disableBoxShadow', 'bgColor', 'isToReceive', 'isExpanded'].includes(
      prop as string
    )
})<WrapperProps>(({ theme, bgColor, isToReceive, isExpanded }) => ({
  position: 'relative',
  ...(!isToReceive &&
    !isExpanded && {
      borderRadius: 12
    }),
  ...(!isToReceive &&
    isExpanded && {
      borderTopLeftRadius: 12,
      borderTopRightRadius: 12,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottom: 'none'
    }),
  ...(isToReceive &&
    isExpanded && {
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderBottomLeftRadius: 12,
      borderBottomRightRadius: 12,
      borderTop: 'none'
    }),

  border: `1px solid ${theme.palette.neutral[700]}`,
  overflow: 'visible', // Alterado de 'hidden' para 'visible'
  display: 'grid',
  // minmax(160px, ...) garante espaço para valores monetários (ex: "R$ 28.948,24"),
  // que precisam de ~110px além dos 54px de padding do Content.
  gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',

  [theme.breakpoints.between(900, 1500)]: {
    gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))'
  },
  [theme.breakpoints.down(900)]: {
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))'
  },
  [theme.breakpoints.down(600)]: {
    gridTemplateColumns: '1fr'
  },
  ...(bgColor && { backgroundColor: bgColor }),
  width: '100%'
}))

type ContentProps = {
  canFilter?: boolean
  isMobile?: boolean
  isSelected?: boolean
  isExpanded?: boolean
  level?: number
}

export const Content = styled('button', {
  shouldForwardProp: (prop) =>
    !['canFilter', 'isMobile', 'isSelected', 'isExpanded', 'level'].includes(
      prop as string
    )
})<ContentProps>(({ theme, canFilter, isMobile, isSelected, isExpanded }) => ({
  all: 'unset',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  // Grid items têm min-width: auto por default e não encolhem abaixo do conteúdo.
  minWidth: 0,
  ...(isMobile && {
    borderBottom: `1px solid ${theme.palette.neutral[700]}`
  }),
  ...(!isMobile && { borderLeft: `1px solid ${theme.palette.neutral[700]}` }),
  padding: `20px ${isMobile ? '10px' : ' 27px'}`,
  rowGap: 4,
  transition: 'all 0.2s ease-in-out',
  // Estilo para card selecionado (filtro ativo) - apenas borda esquerda verde
  ...(isSelected && {
    borderLeftColor: theme.palette.primary.main,
    borderLeftWidth: '3px',
    background: theme.palette.neutral[800]
  }),
  // Estilo para card expandido (pai de sub-cards) - apenas background mais escuro
  ...(isExpanded && {
    background: theme.palette.neutral[850] || theme.palette.neutral[900]
  }),
  '&': {
    ...(canFilter && {
      '&:hover, &:focus-within': {
        cursor: 'pointer',
        background: isSelected
          ? theme.palette.neutral[700]
          : theme.palette.neutral[900]
      }
    })
  },
  '&:first-of-type': {
    borderLeft: isSelected ? `3px solid ${theme.palette.primary.main}` : '0'
  }
}))

export const Heading = styled('h3')(({ theme }) => ({
  font: 'normal 400 14px Inter, "sans-serif"',
  color: theme.palette.neutral[300],
  margin: 0,
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
}))

export const SubtitleWrapper = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 4,
  minWidth: 0
}))

export const Subtitle = styled('p')(({ theme }) => ({
  font: 'normal 500 18px Inter, sans-serif',
  color: theme.palette.neutral[200],
  margin: 0,
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
}))
